import axios from 'axios';

// Configuración base para el servicio de fechas bloqueadas
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const blockedDateAPI = axios.create({
  baseURL: `${API_BASE_URL}/blocked-date`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para manejo de errores
blockedDateAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Blocked Date Service Error:', error);
    return Promise.reject(error);
  }
);

// Servicios de fechas bloqueadas
export const blockedDateService = {
  // Obtener todas las fechas bloqueadas
  getAll: async () => {
    try {
      const response = await blockedDateAPI.get('/');
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener las fechas bloqueadas: ' + error.message);
    }
  },
};

export default blockedDateService;
